import PropTypes from "prop-types";
import { memo } from "react";

import { useCurrentFormatCurrency } from "@hooks/usePrices";
import { cn } from "@helpers/general";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";

import { ComponentType } from "@constants/ComponentType";

function FullPrice({ componentType, price, hasDiscount, showLuxePrices, isStartingAt = false }) {
  const formatWithCurrency = useCurrentFormatCurrency();
  return (
    <p
      className={cn("font-bold", {
        "text-dark-grey": hasDiscount,
        "typo-body": componentType !== ComponentType.PDP && componentType !== ComponentType.PDP_ADS,
        "typo-h2 desktop:typo-h3":
          componentType === ComponentType.PDP || componentType === ComponentType.PDP_ADS,
        strikethrough:
          hasDiscount || (componentType === ComponentType.SIDE_CART_UPSELL && showLuxePrices),
      })}
      data-testid="fullPrice"
    >
      {isStartingAt && (
        <span
          className={cn(
            "font-normal text-dark-grey",
            componentType === ComponentType.CP && "typo-micro",
            (componentType === ComponentType.PDP || componentType === ComponentType.PDP_ADS) &&
              "typo-body"
          )}
        >
          Starting at
          <br />
        </span>
      )}
      {formatWithCurrency(price)}
    </p>
  );
}

FullPrice.propTypes = {
  componentType: PropTypes.string,
  price: PropTypes.number,
  hasDiscount: PropTypes.bool,
  showLuxePrices: PropTypes.bool,
  isStartingAt: PropTypes.bool,
};

export default withALErrorBoundary({
  name: "FullPrice",
  priority: "P1",
})(memo(FullPrice));
